import { LTitle } from "@components";
import WelcomePage from "@assets/WelcomePage.png";

export const PricingHeader = (): JSX.Element => {
    return (
        <div className="columns">
            <div className="column is-two-fifths">
                <img src={WelcomePage} className="has-background-lightest-blue p-6 is-borders-rounded" />
            </div>
            <div className="column">
                <LTitle color="has-text-dark-blue">LASSI-D™</LTitle>
                <p className="has-text-primary">David A. Loewenstein, PhD, Rosie E. Curiel, PsyD</p>
                <p className="mt-5 has-text-ldark-gray">
                    LASSI-D™ is the brief digital commercial version of the well known and validated LASSI-L™. The
                    LASSI-L™ is a paper & pencil based cognitive stress test that has been proven to be effective in
                    detecting cognitive changes among older adults with the earliest stages of Mild Cognitive Impairment
                    and asymptomatic older adults with preclinical Alzheimer’s disease. The LASSI-D™ is cloud-based and
                    fully self-administered, under the supervision of a healthcare professional. It provides
                    standardized administration, instant access to automated scoring results and clear recommendations
                    for follow-up. It can be deployed on multiple browser-based platforms & devices.
                </p>
            </div>
        </div>
    );
};
